import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.3q.1-1 1.1-1.1zm4.5 1.6q1 .1 1.1 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1zM4.4 4.8q1.1 0 1.2 1.2v17.2q.1 1.5 1.6 1.6H15v2.4H7.2a4 4 0 0 1-4-4V6q0-1.1 1.2-1.2M25.2 10a1.2 1.2 0 0 1 1.6 1.6l-4 4.2h-.2c-1.7 0-3 1.3-3.1 3q-.6.1-1.2-.4l-4-3.9-4.3 4.3a1.2 1.2 0 0 1-1.7-1.7l5.3-5.1q.8-.8 1.7 0l3.9 4z" })
});
export default SvgChartLineRegularReportIcon;
